import React, { useState, useEffect } from 'react';
import { rutasService } from '../../services/api';
import apiConfig from '../../config/api.config';

const TestConnection: React.FC = () => {
  const [status, setStatus] = useState<string>('Probando conexión...');
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const testConnection = async () => {
      try {
        console.log('🔄 Probando conexión frontend-backend...');
        
        // Probar endpoint de prueba
        const testResponse = await fetch(apiConfig.endpoints.rutasTest);
        const testData = await testResponse.json();
        
        console.log('✅ Test endpoint response:', testData);
        
        // Probar endpoint de tabla con datos reales
        const tableResponse = await fetch(`${apiConfig.endpoints.rutasTabla}?page=1&per_page=3`);
        const tableData = await tableResponse.json();
        
        console.log('✅ Table endpoint response:', tableData);
        
        setStatus('Conexión exitosa');
        setData({
          test: testData,
          table: tableData
        });
        
      } catch (err: any) {
        console.error('❌ Error de conexión:', err);
        setError(err.message);
        setStatus('Error de conexión');
      }
    };

    testConnection();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h2>Test de Conexión Frontend-Backend</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <strong>Estado:</strong> {status}
      </div>
      
      {error && (
        <div style={{ color: 'red', marginBottom: '20px' }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {data && (
        <div>
          <h3>Respuesta del Backend:</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', fontSize: '12px', overflow: 'auto' }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default TestConnection;
